import { authenticatedBitswanBackendInstance } from "@/lib/api-client";

export type SupportMessage = {
  id: string;
  side: "org" | "platform";
  kind: "text" | "event";
  event: string;
  sender_name: string;
  sender_email: string;
  body: string;
  created_at: string;
};

export type SupportConversation = {
  id: string;
  organization_id: string;
  organization_name: string;
  organization_kind: "customer" | "advisor";
  opened_by_name: string;
  opened_by_email: string;
  assigned_to_email: string;
  last_message_at: string | null;
  last_message_preview: string;
  unread: number;
  created_at: string;
};

export type SupportThread = { conversation: SupportConversation | null; messages: SupportMessage[] };

function headers(orgId?: string) {
  return orgId ? { "X-Org-Id": orgId } : {};
}

export async function fetchSupportThread(orgId?: string) {
  const api = await authenticatedBitswanBackendInstance(headers(orgId));
  const res = await api.get("/support/conversation/");
  return res.data as SupportThread;
}

export async function sendSupportMessage(body: string, orgId?: string) {
  const api = await authenticatedBitswanBackendInstance(headers(orgId));
  const res = await api.post("/support/conversation/", { body });
  return res.data as SupportThread;
}

export async function fetchSupportUnread(orgId?: string) {
  const api = await authenticatedBitswanBackendInstance(headers(orgId));
  const res = await api.get("/support/unread/");
  return res.data as { unread: number };
}
